import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1259de28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marquee" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "marquee-overlay" }, null, -1))
const _hoisted_3 = { class: "marqueeone" }
const _hoisted_4 = { class: "marqueetwo" }
const _hoisted_5 = { class: "marqueethree" }
const _hoisted_6 = { class: "marqueefour" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarqueeScrollSO',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
}



const marqueeTitle = ref(props.title);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("label", _hoisted_3, _toDisplayString(marqueeTitle.value), 1),
    _createElementVNode("label", _hoisted_4, _toDisplayString(marqueeTitle.value), 1),
    _createElementVNode("label", _hoisted_5, _toDisplayString(marqueeTitle.value), 1),
    _createElementVNode("label", _hoisted_6, _toDisplayString(marqueeTitle.value), 1)
  ]))
}
}

})